import { Box, Text } from "@chakra-ui/react";
import { McpMonthlyUsage } from "@intentsify/dto";
import { UsageMonth, formatUsageMonth } from "@intentsify/utils";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { Table } from "../Table";
import { formatNumber } from "./McpUsage.utils";

type McpUsageHistoryTableProps = {
  /** Rolling last-12-months usage, most recent first. */
  months: McpMonthlyUsage[];
};

const McpUsageHistoryTable = ({ months }: McpUsageHistoryTableProps) => {
  const columns = useMemo<ColumnDef<McpMonthlyUsage>[]>(
    () => [
      {
        header: "Month",
        accessorKey: "periodStart",
        cell: (c) => formatUsageMonth(c.getValue<UsageMonth>()),
      },
      {
        header: "Used",
        accessorKey: "creditsUsed",
        cell: (c) => formatNumber(c.getValue<number>()),
      },
    ],
    [],
  );

  return (
    <Box>
      {months.length > 0 && (
        <Text color="gray.500" fontSize="sm" mb={2}>
          Monthly usage
        </Text>
      )}
      <Table
        columns={columns}
        data={months}
        isControlledByAPI={false}
        hidePagination
        isScrollable={false}
        defaultPageSize={12}
        variant="intentsifyClean"
        noDataMessage="No monthly usage yet."
      />
    </Box>
  );
};

export { McpUsageHistoryTable };
